<template>
	<div
		aria-hidden="true"
		:class="$style['progress-bar']"
	>
		<div
			:class="$style['progress-bar__fill']"
			:style="fillStyle"
			@animationend="$emit('end')"
		/>
	</div>
</template>

<script>
export default {
	name: 'NotificationProgressBar',
	props: {
		duration: {
			type: Number,
			required: true
		},
		paused: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		fillStyle () {
			return {
				animationDuration: `${this.duration}ms`,
				animationPlayState: this.paused ? 'paused' : 'running'
			}
		}
	}
}
</script>

<style lang="scss" module>
.progress-bar {
    width: 100%;
    height: 3px;
    overflow: hidden;
    background-color: getColor(border-light);

    &__fill {
        width: 100%;
        height: 100%;
        transform-origin: left center;
        background-color: getColor(primary);
        animation-name: notification-progress;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
    }
}

@keyframes notification-progress {
    from {
        transform: scaleX(1);
    }

    to {
        transform: scaleX(0);
    }
}
</style>
